import axios from 'axios';
import { getEnvironmentConstant } from '../common/utilities';
import { ROUTER_BASENAME } from '../common/constants';
import logger from '../common/logger';

const fetchLearnLiveCourseById = async ({ entryId, env }) => {
  // Call the new API endpoint for fetching a single LearnLiveCourse by entryId
  const routerBasename = getEnvironmentConstant({ env, key: ROUTER_BASENAME });
  const apiUrl = `${routerBasename}/api/learnLiveCourse/v1/${entryId}`;
  logger.info('Fetching LearnLiveCourse detail data from client', {
    env,
    entryId,
    routerBasename,
    apiUrl,
  });
  const response = await axios.get(apiUrl);
  // The response will be the course object or 404
  return response.data;
};

export default fetchLearnLiveCourseById;
